import { render, staticRenderFns } from "./ExpedienteExternalLinkViewer.vue?vue&type=template&id=70b8cec7&"
import script from "./ExpedienteExternalLinkViewer.vue?vue&type=script&lang=js&"
export * from "./ExpedienteExternalLinkViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports